import { Component, ElementRef, HostListener, Input, Output, EventEmitter, ViewChild, inject, PLATFORM_ID } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { KebabListComponent } from '../kebab-features/kebab-list-component/kebab-list-component';
import { KebabRatingComponent } from '../kebab-features/kebab-rating-component/kebab-rating-component';
import { KebabWatchToListComponent } from '../kebab-features/kebab-watch-to-list-component/kebab-watch-to-list-component';
import { KebabFavouriteComponent } from '../kebab-features/kebab-favourite-component/kebab-favourite-component';
import { ToastService } from '../../toast/toast.service';
import { LanguageService } from '../../../core/services/language/language.service';
import { getStoredAuthToken } from '../../../core/auth/auth-token';

@Component({
  selector: 'app-kebab-component',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule, 
    KebabListComponent, 
    KebabRatingComponent,
    KebabWatchToListComponent,
    KebabFavouriteComponent
  ],
  templateUrl: './kebab-component.html',
  styleUrls: ['./kebab-component.scss']
})

export class KebabComponent {

  @Input() isActive = false;
  @Output() toggle = new EventEmitter<KebabComponent>();
  @Input() data: any = null;

  @ViewChild('dropdownRef') dropdownRef?: ElementRef;

  private readonly toast = inject(ToastService);
  private readonly router = inject(Router);
  private readonly languageService = inject(LanguageService);
  private readonly platformId = inject(PLATFORM_ID);
  
  constructor(
    public el: ElementRef,
  ) {}

  dropDownKebab(event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    if (isPlatformBrowser(this.platformId)) {
      const token = getStoredAuthToken();
      if (!token) {
        this.toast.warning(
          this.languageService.t('loginRequiredTitle') || 'Login Required',
          this.languageService.t('loginRequiredMessage') || 'Please log in to perform this activity.'
        );
        this.clearCardBlur();
        const returnUrl = this.router.url || '/';
        this.router.navigate(['/auth'], { queryParams: { redirect: returnUrl } });
        return;
      }
    }

    this.isActive = !this.isActive;
    this.toggle.emit(this); 
    if (!this.isActive) {
      this.clearCardBlur();
    }
  }

  closeMenu() {
    if (this.isActive) {
      this.isActive = false;
      this.toggle.emit(this);
    }
    this.clearCardBlur();
  }

  clearCardBlur() {
    try {
      const host = this.el?.nativeElement as HTMLElement;
      if (host) {
        const card = host.closest('.movie-card, .trailer-card, .blurred') as HTMLElement;
        if (card) {
          card.classList.remove('blurred');
        }
      }
    } catch (_) {}
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.isActive) return;
    if (!this.el.nativeElement.contains(event.target)) {
      this.closeMenu();
    }
  }

  get cardElement(): HTMLDivElement | null {
    return this.el.nativeElement.closest('div'); 
  } 
}